var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.0674 61.166H17.8307C13.0641 61.166 9.16406 65.066 9.16406 69.8327V95.8327H38.0674V61.166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2601 43.834H46.6901C41.9234 43.834 38.0234 47.734 38.0234 52.5007V95.834H66.9268V52.5007C66.9268 47.734 63.0701 43.834 58.2601 43.834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.1663 74.166H66.9297V95.8327H95.833V82.8327C95.833 78.066 91.933 74.166 87.1663 74.166Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5452 21.5174C66.8885 20.1741 67.4086 18.5708 66.9752 17.1841C66.5419 15.7974 65.1986 14.8008 63.2919 14.4975L59.1319 13.8041C58.9586 13.7608 58.5686 13.5007 58.4819 13.3274L56.1852 8.73406C54.4519 5.22406 50.5086 5.22406 48.7752 8.73406L46.4786 13.3274C46.3919 13.5007 46.0019 13.7608 45.8286 13.8041L41.6686 14.4975C39.7619 14.8008 38.4619 15.7974 37.9852 17.1841C37.5519 18.5708 38.0719 20.1741 39.4152 21.5174L42.6219 24.7675C42.7519 24.8974 42.9252 25.4175 42.8819 25.5908L41.9719 29.5774C41.2786 32.5241 42.4052 33.8674 43.1419 34.4307C43.8786 34.9507 45.4819 35.6441 48.1252 34.0841L52.0252 31.7874C52.1986 31.6574 52.7619 31.6574 52.9352 31.7874L56.8352 34.0841C58.0486 34.8208 59.0452 35.0374 59.8252 35.0374C60.7352 35.0374 61.3852 34.6907 61.7752 34.4307C62.5119 33.9107 63.6386 32.5674 62.9452 29.5774L62.0352 25.5908C61.9919 25.3741 62.1219 24.8974 62.2952 24.7675L65.5452 21.5174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon2);
export default __webpack_public_path__ + "static/media/about_icon_2.bdbcc50d2ba90828851ed406138b4fb1.svg";
export { ForwardRef as ReactComponent };